// Google encoded-polyline decoder. Archived trips have their raw breadcrumb
// points pruned server-side and come back as a single simplified string, so the
// map needs to expand it back into coordinates before drawing.
export const decodePolyline = (encoded, precision = 5) => {
    if (typeof encoded !== 'string' || !encoded) return [];

    const factor = 10 ** precision;
    const points = [];
    let index = 0;
    let lat = 0;
    let lng = 0;

    while (index < encoded.length) {
        let result = 1;
        let shift = 0;
        let b;

        do {
            b = encoded.charCodeAt(index++) - 63 - 1;
            result += b << shift;
            shift += 5;
        } while (b >= 0x1f && index < encoded.length);
        lat += (result & 1) ? ~(result >> 1) : (result >> 1);

        result = 1;
        shift = 0;
        do {
            b = encoded.charCodeAt(index++) - 63 - 1;
            result += b << shift;
            shift += 5;
        } while (b >= 0x1f && index < encoded.length);
        lng += (result & 1) ? ~(result >> 1) : (result >> 1);

        points.push([lat / factor, lng / factor]);
    }

    return points;
};

// Metres between two [lat, lng] pairs — haversine. Used to total a route's
// distance from its points, since the trip header doesn't carry one.
export const haversineMetres = ([lat1, lon1], [lat2, lon2]) => {
    const R = 6371000;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) ** 2
        + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(a));
};

export const routeLengthMetres = (points = []) => {
    let total = 0;
    for (let i = 1; i < points.length; i += 1) total += haversineMetres(points[i - 1], points[i]);
    return total;
};

export const fmtDistance = (metres) => {
    if (!Number.isFinite(metres) || metres <= 0) return '—';
    return metres < 1000 ? `${Math.round(metres)} m` : `${(metres / 1000).toFixed(1)} km`;
};
